module.exports = __webpack_public_path__ + "img/cover-3.853ee1fb.png";